import { Button, Modal } from 'antd'
import React, { useRef, useState } from 'react'
import SelectTemplateForm from './SelectTemplateForm';
import FillShippingForm from './FillShippingForm';
import './styles.scss';

const steps = {
  "choose_template": {
    title: "Choose an invoice template",
    btn_name: "Select",
    component: ({ setTemplateId, setStep, templateId }) => (
      <SelectTemplateForm setTemplateId={setTemplateId} setStep={setStep} templateId={templateId} />
    ),
  },
  "fill_info": {
    title: "Fill attributes for an account",
    btn_name: "Create Invoice",
    component: ({ templateId, selectedIds, close, formRef }) => <FillShippingForm templateId={templateId} selectedIds={selectedIds} ref={formRef} close={close} />,
  },
};

const PrintInvoiceForm = ({ visible, close, selectedIds, setTransactionsData, resetFilters, setNewInvoiceId }) => {

  const formRef = useRef(null);

  const handleSelectTemplate = () => {
      formRef.current?.submit();
  };
  
  return (
    <Modal
      width="90vw"
      destroyOnClose
      visible={visible}
      onCancel={close}
      // onOk={onOk}
      closable={false}
      maskClosable
      title={"Fill attributes for an account"}
      footer={[
        <div className="invoice_modal__footer">
        <Button
        className="invoice_modal__footer_btn" 
        type="primary" 
        key="forward" 
        onClick={handleSelectTemplate}
        >
          Submit
        </Button>
        </div>
      ]}
    >
      <FillShippingForm selectedIds={selectedIds} ref={formRef} close={close} setTransactionsData={setTransactionsData} resetFilters={resetFilters} setNewInvoiceId={setNewInvoiceId} />
    </Modal>
  )
}

export default PrintInvoiceForm
